@let availability = (currentAvailability$ | async)?.data;
@let online = (isOnline$ | async) ?? false;

<div class="w-80 p-4 bg-foreground rounded-lg">
  @if (availability) {
    <div class="flex items-start gap-3">
      <span
        class="mt-1 h-3 w-3 rounded-full flex-none"
        [style.background-color]="
          online ? 'var(--color-success)' : 'var(--color-danger)'
        "></span>
      <div class="min-w-0">
        <p class="text-base font-semibold text-default leading-tight">
          {{ online ? 'Open' : 'Closed' }}
        </p>
        <p class="text-sm text-secondary">{{ statusSubtitle(availability) }}</p>
      </div>
    </div>

    <hr class="my-3 border-divider" />

    @if (canManage$ | async) {
      <div class="flex items-center justify-between gap-3">
        <span class="text-sm font-medium text-default">Accept online orders</span>
        <mat-slide-toggle
          color="primary"
          [checked]="online"
          [disabled]="(actionInProgress$ | async) ?? false"
          (change)="toggleOnlineOrders(online, $event)">
        </mat-slide-toggle>
      </div>
    } @else {
      <div
        class="flex items-center gap-2 text-sm text-secondary"
        matTooltip="Only admins can change availability.">
        <mat-icon svgIcon="mat:lock" class="icon-sm"></mat-icon>
        <span>Only admins can change availability.</span>
      </div>
    }

    <hr class="my-3 border-divider" />

    <button
      type="button"
      mat-button
      color="primary"
      class="w-full"
      (click)="manageAvailability()">
      Manage availability
    </button>
  } @else {
    <div class="flex items-center justify-center py-4 text-sm text-secondary">
      Loading…
    </div>
  }
</div>
